// The Receipts list keeps its filters in the URL so the detail page can rebuild
// the same list (for previous/next and the review queue) and "Back" lands on
// the view you left.
import { ReceiptListFilters, ReceiptStatus, ReceiptType } from "../api/client";

export type AttachmentFilter = "" | "yes" | "no";

export interface ListView {
  status: "" | ReceiptStatus;
  type: "" | ReceiptType;
  att: AttachmentFilter;
  q: string;
}

export function readView(p: URLSearchParams): ListView {
  return {
    status: (p.get("status") || "") as ListView["status"],
    type: (p.get("type") || "") as ListView["type"],
    att: (p.get("att") || "") as AttachmentFilter,
    q: p.get("q") || "",
  };
}

export function toApiFilters(v: ListView): ReceiptListFilters {
  return {
    status: v.status || undefined,
    type: v.type || undefined,
    has_attachments: v.att === "yes" ? true : v.att === "no" ? false : undefined,
    q: v.q.trim() || undefined,
  };
}
